var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section py-8"},[_c('div',{staticClass:"flex flex-col mx-auto",class:_vm.containerClass},[_c('div',{staticClass:"section-header px-4 lg:px-0"},[_c('h2',{staticClass:"text-lg md:text-xl"},[_vm._t("heading")],2)]),_c('div',{staticClass:"p-4 lg:p-0"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }